export enum SupportedChannelMessageEnum {
  QUICK_ACTION = 'quickAction',
  UNREAD_MESSAGE = 'unreadConversationsCountChange',
  HEARTBEAT = 'heartBeat',
  REINITIALIZE = 'reinitialize',
  HISTORY_BACK = 'historyBack',
  DOWNLOAD_FILE = 'downloadFile',
}
